import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
import Image from "next/image";

const BannerImage = ({ image, title }) => {
    return (
        <div style={{ position: "relative", width: "100%" }}>
            <Image
                src={`${NEXT_IMAGE_CDN}/${image}`}
                alt={title}
                width={0}
                height={0}
                priority={true}
                sizes="(max-width: 768px) 100vw"
                className="object-cover w-full h-full"
            />
        </div>
    );
};

export default BannerImage;
